module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-tabs">\n    <span data-sort="alphabetical">Alphabetical</span>\n    <span data-sort="created">Created Date</span>\n</div>\n<input class="content-filtering" type="search" placeholder="Search">\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/dashboard/TemplateSortingPanel.tpl
// module id = 2894
// module chunks = 0